function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSuitcaseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.867 3.581l-.936-2.529-.935 2.53-2.53.935 2.53.936.935 2.53.936-2.53 2.53-.936-2.53-.936zM26.732 8.733l-1.56-4.216-1.56 4.216-4.215 1.56 4.215 1.56 1.56 4.216 1.56-4.216 4.216-1.56-4.216-1.56z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.172 16.069l-1.56-4.216-4.215-1.56 4.215-1.56 1.56-4.216 1.56 4.216 4.216 1.56-4.216 1.56-1.56 4.216zm0-5.468c.092-.114.195-.217.309-.308a2.003 2.003 0 01-.309-.308 2.004 2.004 0 01-.308.308c.114.091.217.195.308.308zm-9.24-9.549l-.937 2.53-2.529.935 2.53.936.935 2.53.936-2.53 2.53-.936-2.53-.936-.936-2.529zm1.465 15.017v13.86h4.31c.638 0 1.155-.516 1.155-1.154V17.224c0-.638-.517-1.155-1.155-1.155h-4.31zm-1.733 0H9.268v13.86h6.396V16.07zm-8.129 0h-4.31c-.638 0-1.155.517-1.155 1.155v11.55c0 .639.517 1.156 1.155 1.156h4.31V16.069zm.359-1.454a4.676 4.676 0 00-.048.247h1.919a2.808 2.808 0 012.701-2.03 2.809 2.809 0 012.701 2.03h1.92a4.666 4.666 0 00-.85-2 4.679 4.679 0 00-3.77-1.905 4.679 4.679 0 00-4.573 3.658z",
    fill: props.color
  }));
}

export default SvgIconSuitcaseFilled;